import { StandaloneSearchBox } from "@react-google-maps/api";
import React, { useCallback, useRef, useState } from "react";
import "./PlacesSearchBar.scss";

interface PlacesSearchBarProps {
  onPlaceSelected: (place: google.maps.places.PlaceResult) => void;
}

const PlacesSearchBar: React.FC<PlacesSearchBarProps> = ({
  onPlaceSelected,
}) => {
  const searchBoxRef = useRef<google.maps.places.SearchBox | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [searchText, setSearchText] = useState("");

  const clearSearchText = useCallback(() => {
    setSearchText("");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  }, []);

  const handleSearchInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(e.target.value);
    },
    []
  );

  const handlePlacesChanged = useCallback(() => {
    if (searchBoxRef.current) {
      const places = searchBoxRef.current.getPlaces();
      if (places && places.length > 0) {
        onPlaceSelected(places[0]);
        clearSearchText();
      }
    }
  }, [onPlaceSelected, clearSearchText]);

  const onLoad = useCallback((ref: google.maps.places.SearchBox) => {
    searchBoxRef.current = ref;
  }, []);

  return (
    <div className="places-search-bar-container">
      <StandaloneSearchBox
        onLoad={onLoad}
        onPlacesChanged={handlePlacesChanged}
      >
        <>
          <input
            ref={inputRef}
            name="search-input"
            type="text"
            onInput={handleSearchInputChange}
            placeholder="Search for a place to play pool"
          />
          {searchText.length > 0 && (
            <span
              className="clear-btn material-symbols-outlined"
              onClick={clearSearchText}
            >
              close
            </span>
          )}
        </>
      </StandaloneSearchBox>
    </div>
  );
};

export default React.memo(PlacesSearchBar);
